export type EasyMarketWebEnv = "local" | "dev" | "demo" | "prod";

export const currentEnv: EasyMarketWebEnv = "prod";

const env: EasyMarketWebEnv = currentEnv;

export const Env: EasyMarketWebEnv = env;

const API_LOCAL_URL = "http://localhost:8000";
/** Préprod / recette */
const API_DEV_URL = "https://api.dev.easymarket.sn/";
const API_RECETTE_URL = "https://api.recette.dev.easymarket.sn";
/** Production */
const API_PROD_URL = "https://api.easymarket.sn";

const VENDEUR_APIKEY_LOCAL =
  "5ce65db6ff7ae13c0f517432a3b186f25217a69c2e429561f0e416d5f6e0b8b6";
const VENDEUR_APIKEY_RECETTE =
  "f05e7d47e568bdd918c7fe4820b347b15b33f86823e7018d7a1254bf0c897706";
const VENDEUR_APIKEY_PROD =
  "f05e7d47e568bdd918c7fe4820b347b15b33f86823e7018d7a1254bf0c897706";

export const APP_URL_LOCAL = "http://localhost:3000/";
export const APP_URL_DEV = "https://recette.dev.easymarket.sn/";
export const APP_URL_DEMO = "https://recette.dev.easymarket.sn/";
export const APP_URL_PROD = "https://easymarket.sn/";

function stripTrailingSlashes(url: string): string {
  return url.replace(/\/+$/, "");
}

const API_URL_FROM_ENV = process.env.REACT_APP_EASYMARKET_API_URL?.trim();
const VENDEUR_KEY_FROM_ENV = process.env.REACT_APP_VENDEUR_API_KEY?.trim();

function processApiUrl(): string {
  if (API_URL_FROM_ENV) return stripTrailingSlashes(API_URL_FROM_ENV);
  if (env === "local") return stripTrailingSlashes(API_LOCAL_URL);
  if (env === "prod") return stripTrailingSlashes(API_PROD_URL);
  if (env === "demo" || env === "dev") return stripTrailingSlashes(API_RECETTE_URL);
  return stripTrailingSlashes(API_RECETTE_URL);
}

function processAppUrl(): string {
  if (env === "local") return APP_URL_LOCAL;
  if (env === "prod") return APP_URL_PROD;
  if (env === "demo") return APP_URL_DEMO;
  return APP_URL_DEV;
}

function processApikey(): string {
  if (VENDEUR_KEY_FROM_ENV) return VENDEUR_KEY_FROM_ENV;
  if (env === "local") return VENDEUR_APIKEY_LOCAL;
  if (env === "prod") return VENDEUR_APIKEY_PROD;
  return VENDEUR_APIKEY_RECETTE;
}

export const ApiBaseUrl = processApiUrl();
export const AppBaseUrl = processAppUrl();

export const VendeurApikey = processApikey();

export const GoogleApikey = "AIzaSyD0klc1PQS8QK--Be3rF3i8kW_idy04AVQ";

export const IntechApikey = "554ACA96-F050-442D-8E29-BEE77FAE821A";

export const GoogleClientId =
  "701177325323-33rje48k1alj39qmb9vspat9urmmrojn.apps.googleusercontent.com";
